import styled from 'styled-components'
import { BlogThreshold as Threshold } from '../../constants/theme'

export const Container = styled.section`
.infiniteScroll {
  display: flex;
  flex-wrap: wrap;
  margin-left: -25px;
  
  @media (max-width: ${Threshold.tablet}) {
    justify-content: center;
  }
  
  @media (max-width: ${Threshold.phone}) {
    margin-right: -25px;
  }
}
`
